import {
  OwnUpDetail,
  OwnUpFillButtonPrimary,
  OwnUpFillButtonPrimaryAccent,
  OwnUpFloatingModal,
  OwnUpGridContainer,
  OwnUpGridItem,
  OwnUpIcon,
  OwnUpLargeBody,
  OwnUpTextInput
} from '@rategravity/own-up-component-library';
import { SuccessDarkIcon } from '@rategravity/own-up-component-library/icon-library/notification-icons/success-dark';
import React, { useCallback, useState } from 'react';

interface CommentModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (comment: string) => void;
}

const MIN_COMMENT_LENGTH = 20;

export const CommentModal = ({ open, onClose, onSubmit }: CommentModalProps) => {
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const onSubmitClicked = useCallback(() => {
    if (comment.trim().length < MIN_COMMENT_LENGTH) {
      setError(`Comment must be at least ${MIN_COMMENT_LENGTH} characters long.`);
    } else {
      onClose();
      onSubmit(comment.trim());
      setComment(''); // Clear the comment after submission
    }
  }, [comment, onClose, onSubmit]);
  return (
    <OwnUpFloatingModal title="Please submit a comment" open={open} onClose={onClose}>
      <OwnUpGridContainer variant="slim">
        <OwnUpGridItem xs={12}>
          <OwnUpLargeBody variant="body1">
            Please submit a comment explaining this update
          </OwnUpLargeBody>
          <OwnUpTextInput
            label="Comment"
            value={comment}
            error={!!error}
            helperText={error}
            onChange={(e) => setComment(e.target.value)}
          />
          <div>
            {comment.length < MIN_COMMENT_LENGTH ? (
              <OwnUpDetail>
                (Minimum {MIN_COMMENT_LENGTH} characters): {comment.length}/{MIN_COMMENT_LENGTH}
              </OwnUpDetail>
            ) : (
              <OwnUpIcon icon={<SuccessDarkIcon />} />
            )}
          </div>
        </OwnUpGridItem>
        <OwnUpGridItem xs={12}>
          <OwnUpFillButtonPrimary onClick={onSubmitClicked} style={{ margin: '16px' }}>
            Submit
          </OwnUpFillButtonPrimary>
          <OwnUpFillButtonPrimaryAccent onClick={() => onClose()}>
            Cancel
          </OwnUpFillButtonPrimaryAccent>
        </OwnUpGridItem>
      </OwnUpGridContainer>
    </OwnUpFloatingModal>
  );
};
